export default {
  impact_level: { label: "Expected Impact Level" },
  priority: {
    label: "Priority Rating for Implementation of Adaptation Measures",
  },
  key_vun: {
    label: "Key Vulnerabilities Identified from Assessment",
  },

  proposed: {
    label: "Proposed Adaptation Measures to Reduce Vulnerabilities",
  },
};
